import gql from 'graphql-tag'

export const GET_VEHICLE_TYPE = gql`
  query VehicleTypes($filter: GetVehicleTypesFilter) {
    vehicleTypes(filter: $filter) {
      isSuccessful
      message
      vehicleTypes {
        vehicleTypeId
        companyId
        isActive
        manufacturer
        model
        type
        category
        transmissionType
        fuelType
        tonnage
        volume
        hasRelation
      }
    }
  }`

export const VEHICLE_TYPE_MUTATION_CREATE = gql`
  mutation CreateVehicleType($input: CreateVehicleTypeInput!) {
    createVehicleType(input: $input) {
      isSuccessful
      message
      vehicleType {
        vehicleTypeId
        companyId
        manufacturer
        model
        type
        category
        transmissionType
        fuelType
        tonnage
        volume
      }
    }
  }
`

export const VEHICLE_TYPE_MUTATION_UPDATE = gql`
  mutation UpdateVehicleType($input: UpdateVehicleTypeInput!) {
  updateVehicleType(input: $input) {
    isSuccessful
    message
    vehicleType {
      vehicleTypeId
      companyId
      isActive
      manufacturer
      model
      type
      category
      transmissionType
      fuelType
      tonnage
      volume
    }
  }
}
`
